import styled from 'styled-components'

export default styled.div`
  display: flex;
  height: 56px;
  align-items: center;
  margin: 0 26px;

  img {
    width: 32px;
    max-height: 24px;
  }

  .right-container {
    margin-left: 20px
    font-family: 'ABChanel PB Regular S', Arial, sans-serif;
    letter-spacing: -0.4px;
  }

  .provider-name {
    font-size: 12px;
  }

  .footnote {
    font-size: 9px;
    color: #7f7f7f;
  }
`



// WEBPACK FOOTER //
// ./src/styles/PaymentProvider.js